import Vue from "vue";
import BaseService from "./base";

const ArtifactService = {
    
    base: BaseService.base,
    sortMap: {
        date: 'date_made',
        title: 'title',
        person: 'artist_maker',
        number: 'artifact_num',
        service: 'military.service'
    },

    /**
     * Retrieve all of Artifacts
     * @param {*} lang The language, either `en` or `fr`
     */
    all(lang) {
        return Vue.axios.get(`${this.base()}/${lang}/collections/artifact`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Retrieve a Artifact detail
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} slug
     */
    detail(lang, id) {
        // /_html/en/collections/artifact/866304
        // return Vue.axios.get(`${this.base()}/${lang}/collections/artifact/id/${id}`) // for api route
        return Vue.axios.get(`${this.base()}/${lang}/collections/artifact/${id}`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Search Artifacts with params
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     */
    search(lang, query, sort, order='desc', page=1, size=24, output='small') {
        var endpoint = `${this.base()}/_search/`;
        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: "artifact",
                terms: query,
                sort: this.sortMap[sort],
                order: order,
                page: page,
                size: size,
                output: output
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },
       
    /**
     * Get a count of artifacts that satisfy a query
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     */
     count(lang, query, sort, order, page=1, size=30) {
        //  TODO use count api endpoint
        var endpoint = `${this.base()}/_search/`;
        if (sort == 'call_nums') {
            sort = 'number'
        }

        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: "artifact",
                terms: query,
                sort: this.sortMap[sort],
                order: order,
                page: page,
                size: size,
                output: 'min'
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },
};

export default ArtifactService;
